import { SwapStatus } from '@layerswap/widget-types';
/**
 * Every non-identity field of a status notification. These are a snapshot at
 * transition time and never trigger or repeat a delivery. Adding a field to
 * SwapStatusEvent fails check:types until it is classified here.
 */
export const SWAP_STATUS_CONTEXT_FIELDS = Object.keys({
    path: true, fromAddress: true, toAddress: true,
    sourceNetwork: true, destinationNetwork: true, sourceToken: true, destinationToken: true,
});
/** Notification policy is applied after observation, never before recording the baseline. */
export const REPORTED_SWAP_STATUSES = new Set([
    SwapStatus.LsTransferPending, SwapStatus.Completed, SwapStatus.Failed, SwapStatus.Expired,
]);
const MAX_SWAPS = 64;
/** One backend history per widget, independent of modal lifetime and wallet attempts. */
export function createSwapStatusObserver() {
    const swaps = new Map();
    const remember = (id, observation) => {
        swaps.delete(id);
        swaps.set(id, observation);
        while (swaps.size > MAX_SWAPS)
            swaps.delete(swaps.keys().next().value);
    };
    return {
        created(swapId) {
            remember(swapId, { ...swaps.get(swapId), createdHere: true });
        },
        observe(event) {
            const previous = swaps.get(event.swapId);
            remember(event.swapId, { createdHere: previous?.createdHere ?? false, status: event.type });
            if (previous?.status === event.type)
                return false;
            // Opening existing data establishes a silent baseline. All later changes are
            // transitions, including a change from a status the host doesn't subscribe to.
            const transition = previous?.status !== undefined || previous?.createdHere === true;
            return transition && REPORTED_SWAP_STATUSES.has(event.type);
        },
    };
}
